import React, { useRef } from "react";
import Header from "../../header.js";
import Footer from "../../footer.js";
import StreamDisplay from "../../streamDisplay.jsx";
import { videoList } from "../../VideoResults/videoResultsGen1.js";

const resultsArr = videoList.Aki;

class Aki extends React.Component{
    render(){
    
 return(
            <div id="wrapper">

				{/* Header */}
				<Header />

				{/* Menu */}

				{/* Main */}
                <StreamDisplay talentName="Aki Rosenthal" results={resultsArr} />


        {/* Footer */}
            <Footer />

    </div>
    )
}
}

export default Aki